export default __webpack_public_path__ + "static/media/shard-culture-active.19aefa15.jpg";